var _style, _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiThinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AI thinking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .ai-thinking__dot,\n    .ai-thinking__arc {\n      transform-box: fill-box;\n      transform-origin: center;\n    }\n\n    .ai-thinking__dot {\n      animation: ai-thinking-pulse 1.8s ease-in-out infinite;\n    }\n\n    .ai-thinking__dot--two { animation-delay: 0.18s; }\n    .ai-thinking__dot--three { animation-delay: 0.36s; }\n\n    .ai-thinking__arc {\n      animation: ai-thinking-breathe 1.8s ease-in-out infinite;\n    }\n\n    .ai-thinking__arc--lower { animation-delay: 0.36s; }\n\n    @keyframes ai-thinking-pulse {\n      0%, 58%, 100% { opacity: 0.58; transform: scale(0.86); }\n      18% { opacity: 1; transform: scale(1.18); }\n    }\n\n    @keyframes ai-thinking-breathe {\n      0%, 52%, 100% { opacity: 0.48; }\n      24% { opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .ai-thinking__dot,\n      .ai-thinking__arc {\n        animation: none;\n        opacity: 1;\n        transform: none;\n      }\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ai-thinking__arc ai-thinking__arc--upper",
    d: "M4.25 8.1C5.8 5.45 8.55 3.9 11.6 3.9",
    stroke: "#117a73",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ai-thinking__arc ai-thinking__arc--lower",
    d: "M19.75 15.9c-1.55 2.65-4.3 4.2-7.35 4.2",
    stroke: "#e85d3f",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "ai-thinking__dot ai-thinking__dot--one",
    cx: 6.5,
    cy: 12,
    r: 2,
    fill: "#117a73"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "ai-thinking__dot ai-thinking__dot--two",
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#fbfbf8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "ai-thinking__dot ai-thinking__dot--three",
    cx: 17.5,
    cy: 12,
    r: 2,
    fill: "#e85d3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiThinking);
export default __webpack_public_path__ + "static/media/ai-thinking.506ac2b23cb10ba81709bf6eb511e3f4.svg";
export { ForwardRef as ReactComponent };